import { configureStore } from "@reduxjs/toolkit";
import pagerReducer from "./pagerSlice";
import kitchenTypologyFilterReducer from "./kitchenTypologyFilterSlice";
import structureCategoryFilterReducer from "./structureCategoryFilterSlice";
import municipalityFilterReducer from "./municipalityFilterSlice";
import searchResultReducer from "./searchResultSlice";
import kitchenTypologiesReducer from "./kitchenTypologiesSlice";
import structureCategoriesReducer from "./structureCategoriesSlice";
import InitReducer from "./initSlice";

export default configureStore({
    reducer: {
        page: pagerReducer,
        kitchenTypologyFilter: kitchenTypologyFilterReducer,
        structureCategoryFilter: structureCategoryFilterReducer,
        municipalityFilter: municipalityFilterReducer,
        searchResult: searchResultReducer,
        kitchenTypologies: kitchenTypologiesReducer,
        structureCategories: structureCategoriesReducer,
        init: InitReducer,
    },
});